import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, Resolve } from '@angular/router';
import { Campaign } from './campaign.model';
import { CampaignService } from './campaign.service';


@Injectable()
export class CampaignListGuard implements Resolve<Campaign> {

  constructor(public router: Router, private campaignService: CampaignService) { }

  resolve() {
    return this.campaignService.getCampaignList(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/campaign-list.guard.ts